import { render, staticRenderFns } from "./ModalRailDelivery.vue?vue&type=template&id=60b7333a&scoped=true&"
import script from "./ModalRailDelivery.vue?vue&type=script&lang=ts&"
export * from "./ModalRailDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRailDelivery.vue?vue&type=style&index=0&id=60b7333a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7333a",
  null
  
)

export default component.exports